import { useSelector } from "react-redux";

import { useMorphedPackActions } from "store/MorphedPackSlice";
import { appRoutes } from "routes";
import { jjLogger } from "utils/logUtils";

import usePolling from "./usePolling";
import useRouter from "./useRouter";

const useMorphedPack = () => {
  const { loadMorphedPack, generateStandardPhotos, getStatus } = useMorphedPackActions();
  const { morphedPack } = useSelector((state) => state.MorphedPackSlice);
  const { push } = useRouter();
  const { stopPolling } = usePolling();

  const pollStatus = async (morphedPackSlug, expectedStatus, isPreview = false) => {
    try {
      const { data } = await getStatus(morphedPackSlug);
      const { status } = data;

      if (status === expectedStatus) {
        stopPolling();
        isPreview ? push(appRoutes.syaiPackPreview(morphedPackSlug)) : push(appRoutes.syaiPackView(morphedPackSlug));
      }
    } catch (error) {
      jjLogger.logError(`useMorphedPack.js: pollStatus() Error polling for pack status: ${error}`);
      stopPolling();
    }
  };

  const generatePhotos = async (morphedPackSlug) => {
    try {
      await generateStandardPhotos(morphedPackSlug);
    } catch (error) {
      jjLogger.logError(`useMorphedPack.js: generatePhotos() Error generating standard photos: ${error}`);
    }
  };

  return { loadMorphedPack, morphedPack, generateStandardPhotos, generatePhotos, getStatus, pollStatus };
};

export default useMorphedPack;
